import React, {PropsWithChildren} from "react";
import classNames from "classnames";
import ChartOptions from "components/ui/ChartOptions";

type CardProps = {
  icon?: string;
  title?: string;
  type?: "PositiveCard" | "NeutralCard" | "NegativeCard";
  overrideColour?: string;
  tableCard?: boolean;
  chartOptions?: React.ReactNode;
  href?: string | null;
};

const Card: React.FC<PropsWithChildren<CardProps>> = ({
                                                        icon,
                                                        title,
                                                        type,
                                                        overrideColour,
                                                        tableCard,
                                                        chartOptions,
                                                        children,
                                                        href,
                                                      }) => {
  const className = classNames("Card", type, {TableCard: tableCard});
  const overrideColourCss = ({ backgroundColor: overrideColour ? overrideColour : "#fbfbfb" });
  const content = (
    <React.Fragment>
      {title &&
        (href ? (
          <div className="CardHeader">
            <h5 className="CardTitle">
              <a href={href}>
                <span>
                  {icon && <img className="CardIcon" src={icon} alt="Icon" />}
                </span>
                <span>{title}</span>
              </a>
            </h5>
            {chartOptions && <ChartOptions>{chartOptions}</ChartOptions>}
          </div>
        ) : (
          <div className="CardHeader">
            <h5 className="CardTitle">
              <span>
                {icon && <img className="CardIcon" src={icon} alt="Icon" />}
              </span>
              <span>{title}</span>
            </h5>
            {chartOptions && <ChartOptions>{chartOptions}</ChartOptions>}
          </div>
        ))}
      {children}
    </React.Fragment>
  );

  return <div className={className}>{content}</div>;
};

export default Card;
